import React, { useState, useEffect, useRef } from 'react';
import OrderReceipt from './components/OrderReceipt';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import Swal from 'sweetalert2';
import './App.css';

  const alaCarteItems = [
    { name: 'Lean Beef Brisket with gravy', price: 65, unit: 'lb', isGF: true },
    { name: 'Pepper steak', price: 40, unit: 'lb', isGF: true },
    { name: 'Grilled Chicken Breast', price: 34, unit: ['lb', 'pcs'], pricePerAlternateUnit: 12, isGF: true },
    { name: 'Chicken Schnitzel', price: 32, unit: ['lb', 'pcs'], pricePerAlternateUnit: 18, isGF: false },
    { name: 'Chicken pargiot', price: 34, unit: ['lb', 'pcs'], pricePerAlternateUnit: 12, isGF: true },
    { name: 'General Tao chicken', price: 32, unit: 'lb', isGF: false },
    { name: 'Pineapple Chicken', price: 32, unit: 'lb', isGF: false },
    { name: 'Crispy Beef', price: 42, unit: 'lb', isGF: false },
    { name: 'Beef Cabbage Rolls', price: 22, unit: ['lb', 'pcs'], pricePerAlternateUnit: 11.75, isGF: true },
    { name: 'Sweet \'n\' Sour meatballs', price: 28, unit: 'lb', isGF: true },
    { name: 'BBQ Chicken', price: 25, unit: 'ea', isGF: true },
    { name: 'Teriyaki BBQ Chicken', price: 30, unit: 'ea', isGF: true },
    { name: 'Shepherd\'s Pie', price: 24, unit: 'ea', isGF: true },
    { name: 'Homemade Gefilte Fish', price: 18, unit: 'ea', isGF: true },
    { name: 'Beef Pastel', price: 5.25, unit: 'ea', isGF: true },
    { name: 'Moroccan Cooked Salmon', price: 34, unit: ['lb', 'pcs'], pricePerAlternateUnit: 18, isGF: true },
    { name: 'Teriyaki Salmon', price: 36, unit: ['lb', 'pcs'], pricePerAlternateUnit: 15, isGF: true },
    { name: 'Grilled Lemon Salmon', price: 36, unit: ['lb', 'pcs'], pricePerAlternateUnit: 15, isGF: true },
    { name: 'Garlic Baked Potatoes', price: 14, unit: 'lb', isGF: true },
    { name: 'Stir Fry Vegetables', price: 18, unit: 'lb', isGF: true },
    { name: 'Matza Ball Soup (4 balls)', price: 20, unit: 'ea', isGF: false },
    { name: 'Matza Balls NO Soup (4 balls per container)', price: 6, unit: 'cont', isGF: false },
    { name: 'Clear chicken soup', price: 14, unit: 'ea', isGF: true },
    { name: 'Vegetable soup', price: 14, unit: 'ea', isGF: true },
    { name: 'Fancy Seder plates', price: 36, unit: 'ea', isGF: true, isTaxable: true },
    { name: 'Chopped liver w/fried onions', price: 24, unit: 'lb', isGF: true },
    { name: 'Romanian eggplant salad', price: 18, unit: 'lb', isGF: true },
    { name: 'Israeli eggplant salad', price: 18, unit: 'lb', isGF: true },
    { name: 'Babaganoush salad', price: 18, unit: 'lb', isGF: false },
    { name: 'Cucumber salad', price: 10, unit: 'lb', isGF: true },
    { name: 'Salade Cuite', price: 18, unit: 'lb', isGF: true },
    { name: 'Potato Kugel', price: 15, unit: 'ea', isGF: false },
    { name: 'Sweet Kugel', price: 15, unit: 'ea', isGF: false }
  ];
function MainApp() {
  const [menu1Persons, setMenu1Persons] = useState(0);
  const [menu2Persons, setMenu2Persons] = useState(0);
  const [alaCarteSelected, setAlaCarteSelected] = useState({});
  const [delivery, setDelivery] = useState(null); 
  const [checkoutStep, setCheckoutStep] = useState(0); 
  const [subtotal, setSubtotal] = useState(0);
  const [taxes, setTaxes] = useState({ gst: 0, qst: 0, totalTax: 0 });
  const [total, setTotal] = useState(0);
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [orderNumber, setOrderNumber] = useState(Math.floor(1000 + Math.random() * 9000)); 
  const [receiptData, setReceiptData] = useState(null);
  

  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', company: '',
    streetNumber: '', streetName: '', unit: '', city: '', 
    province: 'Quebec', postalCode: '', date: '', time: '',
    cardName: '', ccNumber: '', expDate: '', specialNotes: ''
  });

 // --- DYNAMIC BASE URL ---
const currentHost = window.location.hostname;
let baseURL = '';

if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
  baseURL = 'http://localhost:5001';
} else if (currentHost.includes('paradise-frontend-staging')) {
  // Use the EXACT hostname of your staging frontend here
  baseURL = 'https://paradise-backend-staging.onrender.com';
} else {
  // Live Monolith behavior
  baseURL = '';
}

console.log("DevLogic Debug -> Current Host:", currentHost);
console.log("DevLogic Debug -> Using BaseURL:", baseURL);

  const GST_RATE = 0.05;
  const QST_RATE = 0.09975;
  const deadline = new Date('2026-03-25T23:59:59').getTime();

  // Timer Logic
  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const dist = deadline - now;
      if (dist < 0) return;
      setTimeLeft({
        days: Math.floor(dist / (1000 * 60 * 60 * 24)),
        hours: Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((dist % (1000 * 60)) / (1000 * 60)),
        seconds: Math.floor((dist % (1000 * 60)) / 1000),
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [deadline]);
const API_BASE_URL = window.location.hostname === 'localhost' 
  ? 'http://localhost:5000' 
  : 'https://your-render-app-name.onrender.com';
  // Pricing Logic
 
   useEffect(() => {
    // 1. Menus are always taxable
    const menuTotal = (menu1Persons * 80) + (menu2Persons * 90);
    
    // 2. Split A La Carte into Taxable and Non-Taxable
    let taxableAlaCarte = 0;
    let nonTaxableAlaCarte = 0;

   // Use Object.entries so we get both the Name (key) and the Data (value)
Object.entries(alaCarteSelected).forEach(([itemName, itemData]) => {
  
  // 1. Search using the 'itemName' (the Key)
  const masterItem = alaCarteItems.find(i => 
    i.name.trim().toLowerCase() === itemName.trim().toLowerCase()
  );

  // 2. Calculate the total for this specific item
  const itemTotal = (itemData.qty || 0) * (itemData.price || 0);
  
  // 3. Check the rule
  if (masterItem?.isTaxable === true) {
    taxableAlaCarte += itemTotal;
  } else {
    nonTaxableAlaCarte += itemTotal;
  }
});

    const deliveryFee = delivery === true ? 25 : 0;

    // 3. Only these items get GST/QST
    const taxableSubtotal = menuTotal + taxableAlaCarte + deliveryFee;
    
    // 4. These items are added at the very end WITHOUT tax
    const currentSubtotal = taxableSubtotal + nonTaxableAlaCarte;

    const gstAmount = taxableSubtotal * GST_RATE;
    const qstAmount = taxableSubtotal * QST_RATE;

    setSubtotal(currentSubtotal.toFixed(2));
    setTaxes({
      gst: gstAmount.toFixed(2),
      qst: qstAmount.toFixed(2),
      totalTax: (gstAmount + qstAmount).toFixed(2)
    });
    setTotal((currentSubtotal + gstAmount + qstAmount).toFixed(2));

  // ... rest of your calculation logic ...

  }, [menu1Persons, menu2Persons, alaCarteSelected, delivery, alaCarteItems]); 
  // ^ Added alaCarteItems here to fix the ESLint warning
useEffect(() => {
  if (receiptData) {
    Swal.fire({
      title: `Order #${receiptData.orderNumber} Confirmed!`,
      html: `
        Your order has been successfully placed!<br />
        <strong>A copy has been sent to your email.</strong><br /><br />
        Click below to print your receipt.
      `,
      icon: 'success',
      showCancelButton: true,
      confirmButtonText: 'Print Receipt & Finish',
      cancelButtonText: 'Close',
      allowOutsideClick: false // Prevents accidentally closing without resetting
    }).then((result) => {
      if (result.isConfirmed) {
        // 1. Open the print window
        handlePrintReceipt(receiptData);
        
        // 2. CRITICAL: Reset the session so the next order starts fresh
        resetSession(); 
      } else {
        // 3. If she just clicks "Close", still reset the session
        resetSession();
      }
      
      // Clear the trigger so this useEffect doesn't run again
      setReceiptData(null);
    });
  }
}, [receiptData]);

  // Optimized Date/Time Logic
  const getAvailableTimes = (selectedDate) => {
    if (!selectedDate || delivery) return [];
    
    const date = new Date(selectedDate + "T00:00:00");
    const day = date.getDate();
    const month = date.getMonth() + 1;

    let startH = 7, endH = 19;

    if (month === 4 && (day === 1 || day === 7)) endH = 15;
    if (month === 4 && (day >= 2 && day <= 4)) return [];

    const slots = [];
    for (let h = startH; h < endH; h++) {
      slots.push(`${h.toString().padStart(2, '0')}:00`);
      slots.push(`${h.toString().padStart(2, '0')}:30`);
    }
    if (endH === 15) slots.push("15:00"); else slots.push("19:00");
    return slots;
  };
const validateStep3 = () => {
  // Required for ALL orders
  const requiredContactFields = ['name', 'email', 'phone'];
  for (let field of requiredContactFields) {
    if (!formData[field]) {
      Swal.fire('Missing Information', `Please fill in: ${field.replace(/([A-Z])/g, ' $1').toLowerCase()}`, 'error');
      return false;
    }
  }

  // Address fields ONLY required for DELIVERY
  if (delivery === true) {
    const requiredAddressFields = ['streetNumber', 'streetName', 'city', 'postalCode'];
    for (let field of requiredAddressFields) {
      if (!formData[field]) {
        Swal.fire('Missing Information', `Please fill in: ${field.replace(/([A-Z])/g, ' $1').toLowerCase()}`, 'error');
        return false;
      }
    }

    // Payment required for delivery
    const requiredPaymentFields = ['cardName', 'ccNumber', 'expDate'];
    for (let field of requiredPaymentFields) {
      if (!formData[field]) {
        Swal.fire('Payment Required', 'Delivery orders require credit card information for processing.', 'error');
        return false;
      }
    }
  }

  // Credit card length check (if provided, for both pickup and delivery)
  if (formData.ccNumber && formData.ccNumber.replace(/\s/g, '').length !== 16) {
    Swal.fire('Invalid Card', 'Credit card must be 16 digits', 'error');
    return false;
  }

  return true;
};

  const handleInputChange = (e) => {
  let { id, value } = e.target;

  // 1. Existing Credit Card Formatting
  if (id === 'cardName') value = value.replace(/[^a-zA-Z\s]/g, '');
  if (id === 'ccNumber') value = value.replace(/\D/g, '').slice(0, 16);
  if (id === 'expDate') {
    value = value.replace(/\D/g, '').slice(0, 4);
    if (value.length >= 3) value = value.slice(0, 2) + '/' + value.slice(2);
  }

  // --- NEW: Postal Code Formatting ---
  if (id === 'postalCode') {
    // Clean it: Uppercase, no spaces, max 6 characters
    let cleaned = value.toUpperCase().replace(/\s+/g, '').substring(0, 6);
    
    // Format it: Add the space after the 3rd char (e.g., H9B 2R8)
    if (cleaned.length > 3) {
      value = cleaned.slice(0, 3) + ' ' + cleaned.slice(3);
    } else {
      value = cleaned;
    }
  }
  // ------------------------------------

  setFormData(prev => ({ ...prev, [id]: value }));
};

  const resetSession = () => {
  setMenu1Persons(0); 
  setMenu2Persons(0); 
  setAlaCarteSelected({});
  setDelivery(null); 
  setCheckoutStep(0);
  setFormData({
    name: '', email: '', phone: '', company: '', streetNumber: '', streetName: '',
    unit: '', city: '', province: 'Quebec', postalCode: '', date: '', time: '',
    cardName: '', ccNumber: '', expDate: '', specialNotes: ''
  });
  setOrderNumber(Math.floor(1000 + Math.random() * 9000));
  setReceiptData(null);
  
  // This is the key: Unlock the "Submit" button for the next customer
  setIsSubmitting(false); 
};
const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async () => {
  // Prevent duplicate submissions if a request is already in progress
  if (isSubmitting) return; 
  setIsSubmitting(true);

  const orderData = {
    ...formData, 
    orderNumber,
    menu1Persons,
    menu2Persons,
    notes: formData.specialNotes,
    alaCarte: alaCarteSelected,
    delivery,
    subtotal,
    taxes,
    total
  };

  try {
    const response = await fetch(`${baseURL}/submit-order`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(orderData),
    });

    if (response.ok) {
      const hasCard = !!formData.ccNumber && formData.ccNumber.replace(/\D/g, '').length >= 15;
      
      // Save data for printing
      setReceiptData({
        orderNumber,
        name: formData.name,
        phone: formData.phone,
        email: formData.email,
        date: formData.date,
        time: formData.time,
        delivery,
        menu1Persons,
        menu2Persons,
        alaCarteSelected: { ...alaCarteSelected },
        specialNotes: formData.specialNotes,
        subtotal,
        taxes: { ...taxes },
        total,
        hasCard: hasCard,
        paymentStatus: formData.ccNumber 
          ? 'PRE-PAID (Card on File - Billed when ready)' 
          : 'UNPAID - COLLECT AT PICKUP'
      });
      // No Swal here - the useEffect will handle it after render
    } else {
      throw new Error('Server error');
    }
  } catch (err) {
    Swal.fire({
      title: 'Submission Failed',
      text: 'We could not save your order. Please make sure the server is running.',
      icon: 'error'
    });
  } finally {
    // Re-enable the button once the process is complete (success or failure)
    setIsSubmitting(false);
  }
};

const handlePrintReceipt = (data) => {
  const win = window.open('', '', 'height=900,width=800,left=200,top=100');
  if (!win) {
    Swal.fire('Popup Blocked', 'Please allow popups for this site to print receipts.', 'warning');
    return;
  }

  // 1. Base Taxable amounts (Menus + Delivery always taxed)
  const menuTotal = (data.menu1Persons * 80) + (data.menu2Persons * 90);
  const deliveryFee = data.delivery ? 25 : 0;

  // 2. Initialize A La Carte buckets
  let taxableAlaCarte = 0;
  let nonTaxableAlaCarte = 0;

  // 3. Loop through A La Carte using the Name as the Key
  Object.entries(data.alaCarteSelected || {}).forEach(([itemName, itemData]) => {
    // Lookup the rule from your master list at the top of the file
    const masterItem = alaCarteItems.find(i => 
      i.name.trim().toLowerCase() === itemName.trim().toLowerCase()
    );

    const itemTotal = (itemData.qty || 0) * (itemData.price || 0);

    if (masterItem?.isTaxable === true) {
      taxableAlaCarte += itemTotal;
    } else {
      nonTaxableAlaCarte += itemTotal;
    }
  });

  // 4. Final Calculations for Quebec Taxes
  const totalTaxableAmount = menuTotal + deliveryFee + taxableAlaCarte;
  const gst = totalTaxableAmount * 0.05;
  const qst = totalTaxableAmount * 0.09975;
  const taxesTotal = gst + qst;

  const alaCarteTotal = taxableAlaCarte + nonTaxableAlaCarte;
  const grandTotal = (menuTotal + alaCarteTotal + deliveryFee + taxesTotal).toFixed(2);

  // ... rest of your win.document.write code ...
  // Use pre-computed values from receiptData
  const paymentStatus = data.paymentStatus || (
    data.hasCard 
      ? 'CARD ON FILE – will be billed once order is ready.' 
      : 'PAY AT COUNTER'
  );
  const hasCC = data.hasCard || false;
  const receiptHTML = `
    <html>
    <head>
      <title>Order Receipt #${data.orderNumber || '—'}</title>
      <style>
        body { 
          font-family: Arial, Helvetica, sans-serif;
          margin: 0;
          padding: 0;
          color: #000;
          background: #fff;
          font-size: 13px;
          line-height: 1.35;
        }
        .receipt { 
          max-width: 680px;
          margin: 15px auto;
          padding: 20px;
          border: 2px solid #000;
          box-sizing: border-box;
        }
        .logo {
          display: block;
          margin: 0 auto 15px;
          max-width: 200px;
          height: auto;
        }
        .customer-name {
          text-align: center;
          font-size: 30px;
          margin: 0 0 6px;
          font-weight: bold;
        }
        .order-receipt {
          text-align: center;
          font-size: 18px;
          margin: 0 0 15px;
          font-weight: bold;
        }
        .order-header {
          text-align: center;
          font-size: 16px;
          margin: 0 0 20px;
          font-weight: bold;
        }
        .section {
          margin: 15px 0;
        }
        .two-cols {
          display: flex;
          justify-content: space-between;
          gap: 15px;
        }
        .col {
          flex: 1;
        }
        strong {
          font-weight: bold;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin: 15px 0;
        }
        th, td {
          border: 1px solid #000;
          padding: 8px;
          text-align: left;
        }
        th {
          background: #f0f0f0;
          font-weight: bold;
        }
        .price-col {
          text-align: right;
        }
        .totals {
          margin-top: 10px;
          text-align: right;
          font-size: 14px;
          page-break-inside: avoid;
        }
        .total-line {
          font-weight: bold;
          font-size: 17px;
          margin-top: 8px;
        }
        .payment-box {
          border: 2px solid #000;
          padding: 12px;
          margin: 20px 0;
          text-align: center;
          font-weight: bold;
          font-size: 15px;
          page-break-inside: avoid;
        }
        .notes {
          background: #f9f9f9;
          padding: 12px;
          border: 1px solid #ccc;
          margin: 15px 0;
          white-space: pre-wrap;
        }
        @media print {
          @page { margin: 8mm; size: A4 portrait; }
          body { margin: 0; padding: 0; }
          * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          .receipt { margin: 0; padding: 12mm; width: 100%; border: 1px solid #000; }
          .totals, .payment-box { page-break-inside: avoid; }
          .no-print { display: none; }
        }
      </style>
    </head>
    <body>
      <div class="receipt">
        <img src="${window.location.origin}/images/logo-removebg-preview.png" alt="Paradise Kosher Catering" class="logo" />

        <h1 class="customer-name">${data.name?.toUpperCase() || 'CUSTOMER'}</h1>
        <div class="order-receipt">ORDER RECEIPT</div>
        <div class="order-header">
          Order #: ${data.orderNumber || '—'} • Service: <strong>${data.delivery ? 'Delivery' : 'Pickup'}</strong> • Date: ${data.date || '—'}${data.time ? ` at ${data.time}` : ''}
        </div>

        <div class="section two-cols">
          <div class="col">
            <strong>Customer Info:</strong><br />
            Phone: ${data.phone || '—'}<br />
            Email: ${data.email || '—'}
          </div>
          <div class="col">
            <strong>Order Details:</strong><br />
            ${data.company ? `Company: ${data.company}<br />` : ''}
          </div>
        </div>

        <div class="payment-box">
          PAYMENT STATUS:<br />
          <span style="color: ${hasCC ? '#006400' : '#8B0000'}; font-size: 1.1em;">
            ${paymentStatus}
          </span>
        </div>

        ${data.specialNotes ? `
          <div class="notes">
            <strong>Notes / Special Instructions:</strong><br />
            ${data.specialNotes}
          </div>
        ` : ''}

        <table>
          <thead>
            <tr>
              <th>Item Description</th>
              <th>Unit Price</th>
              <th>Qty</th>
              <th class="price-col">Total</th>
            </tr>
          </thead>
          <tbody>
            ${data.menu1Persons > 0 ? `
              <tr>
                <td>Menu #1 Selection</td>
                <td>$80.00</td>
                <td>${data.menu1Persons} people</td>
                <td class="price-col">$${(data.menu1Persons * 80).toFixed(2)}</td>
              </tr>
            ` : ''}
            ${data.menu2Persons > 0 ? `
              <tr>
                <td>Menu #2 Selection</td>
                <td>$90.00</td>
                <td>${data.menu2Persons} people</td>
                <td class="price-col">$${(data.menu2Persons * 90).toFixed(2)}</td>
              </tr>
            ` : ''}
            ${Object.entries(data.alaCarteSelected || {}).map(([name, item]) => `
              <tr>
                <td>${name}</td>
                <td>$${item.price.toFixed(2)}</td>
                <td>${item.qty} ${item.chosenUnit || ''}</td>
                <td class="price-col">$${(item.qty * item.price).toFixed(2)}</td>
              </tr>
            `).join('')}
            ${data.delivery ? `
              <tr>
                <td>Delivery Fee</td>
                <td>$25.00</td>
                <td>1</td>
                <td class="price-col">$25.00</td>
              </tr>
            ` : ''}
          </tbody>
        </table>

        <div class="totals">
          Subtotal: $${data.subtotal || '0.00'}<br />
          GST (5% on menus & delivery): $${gst.toFixed(2)}<br />
          QST (9.975% on menus & delivery): $${qst.toFixed(2)}<br />
          <div class="total-line">TOTAL: $${grandTotal}</div>
        </div>

        <p style="text-align: center; margin-top: 30px; font-size: 13px;">
          Thank you for your order!<br />
          Please present this receipt at pickup or keep for delivery confirmation.
        </p>
      </div>
    </body>
    </html>
  `;

  win.document.write(receiptHTML);
  win.document.close();
  win.focus();

  // STAGING FIX: Detect if the window is ready and force print
  const triggerPrint = () => {
    if (win.document.readyState === 'complete') {
        win.print();
    } else {
        win.onload = () => win.print();
    }
  };

  // Fallback for Staging network lag
  setTimeout(triggerPrint, 1500);

  win.onafterprint = () => {
    win.close();
    resetSession();
    setReceiptData(null);
  };
};
  const selectMenuQuantity = async (num, current, setter) => {
    const { value } = await Swal.fire({
      title: `MENU #${num} Selection`,
      text: "Minimum 4 people required",
      input: 'select',
      inputOptions: Array.from({length: 47}, (_, i) => i + 4).reduce((acc, v) => ({...acc, [v]: v}), {}),
      inputValue: current || 4,
      showCancelButton: true
    });
    if (value) setter(parseInt(value));
  };

  const selectAlaCarteItem = async (itemName) => {
    const item = alaCarteItems.find(i => i.name === itemName);
    if (!item) {
      Swal.fire('Error', 'Item not found', 'error');
      return;
    }

    const defaultUnit = item.unit || 'lb';
    const current = alaCarteSelected[itemName] || { qty: 0, chosenUnit: Array.isArray(defaultUnit) ? defaultUnit[0] : defaultUnit };

    const hasMultipleUnits = Array.isArray(item.unit) && item.unit.length > 1;

    const { value: formValues } = await Swal.fire({
      title: item.name,
      html: `
        ${hasMultipleUnits ? `
          <div class="alert alert-info small mb-3" style="font-size:0.9rem; padding:10px;">
            You can choose either <strong>lb</strong> or <strong>pcs</strong> for this item.<br>
            Price adjusts automatically based on your selection.
          </div>
        ` : ''}

        <label>Quantity:</label>
        <input type="number" id="swal-qty" class="form-control mb-3" value="${current.qty}" min="1">

        ${hasMultipleUnits ? `
          <label class="form-label">Unit:</label>
          <select id="swal-unit" class="form-select">
            ${item.unit.map(u => `
              <option value="${u}" ${current.chosenUnit === u ? 'selected' : ''}>
                ${u.toUpperCase()} ${u === 'lb' ? `($${item.price}/${u})` : `($${item.pricePerAlternateUnit || item.pricePcs}/${u})`}
              </option>
            `).join('')}
          </select>
        ` : `
          <p class="mt-3 text-muted">
            Fixed unit: <strong>${(item.unit || 'lb').toUpperCase()}</strong>
          </p>
        `}
      `,
      preConfirm: () => ({
        qty: Number(document.getElementById('swal-qty').value) || 0,
        unit: document.getElementById('swal-unit')?.value || (Array.isArray(item.unit) ? item.unit[0] : (item.unit || 'lb'))
      }),
      showCancelButton: true,
      confirmButtonText: 'Add to Order',
      cancelButtonText: 'Cancel'
    });

    if (formValues && formValues.qty > 0) {
      const chosenUnit = formValues.unit;

      let finalPrice = item.price;
      if ((chosenUnit === 'pcs' || chosenUnit === 'ea') && item.pricePerAlternateUnit) {
        finalPrice = item.pricePerAlternateUnit;
      }

      setAlaCarteSelected(prev => ({
        ...prev,
        [itemName]: { qty: formValues.qty, price: finalPrice, chosenUnit }
      }));
    }
  };



  const renderTimer = () => (
    <div className="d-flex justify-content-center w-100 no-print">
      <div id="countdown-banner" className="bg-dark text-center py-3 my-1 rounded border border-warning" style={{ width: '98%' }}>
        <div className="h5 mb-0 font-monospace fw-bold text-warning">
          <div className='text-white'>DEADLINE TO ORDER</div>
          <div className='text-white'>25TH MARCH 2026</div>
          <div className='text-danger'>Minimum Order $200</div>
          <div className="mt-1">{timeLeft.days}d : {timeLeft.hours}h : {timeLeft.minutes}m : {timeLeft.seconds}s</div>
        </div>
      </div>
    </div>
  );

  const renderCartContent = (isMobile = false) => (
    <div className={`card ${isMobile ? 'border-0 rounded-0' : 'sticky-top shadow-sm border-0'}`} style={!isMobile ? { top: '10px' } : {}}>
      <div className="card-body p-2">
        <h5 className="gold border-bottom pb-2 mb-2">Your Order</h5>
        <div style={{ fontSize: '0.75rem' }}>
          {menu1Persons > 0 && <div className="d-flex justify-content-between align-items-center mb-1">
            <span>Menu #1 ({menu1Persons} people)</span>
            <div className="d-flex align-items-center">
              <span className="me-2 fw-bold">${(menu1Persons * 80).toFixed(2)}</span>
              <button className="btn btn-sm btn-link p-0 me-2" onClick={() => selectMenuQuantity(1, menu1Persons, setMenu1Persons)}>✏️</button>
              <button className="btn btn-sm btn-link p-0 text-danger" onClick={() => setMenu1Persons(0)}>🗑️</button>
            </div>
          </div>}
          {menu2Persons > 0 && <div className="d-flex justify-content-between align-items-center mb-1">
            <span>Menu #2 ({menu2Persons} people)</span>
            <div className="d-flex align-items-center">
              <span className="me-2 fw-bold">${(menu2Persons * 90).toFixed(2)}</span>
              <button className="btn btn-sm btn-link p-0 me-2" onClick={() => selectMenuQuantity(2, menu2Persons, setMenu2Persons)}>✏️</button>
              <button className="btn btn-sm btn-link p-0 text-danger" onClick={() => setMenu2Persons(0)}>🗑️</button>
            </div>
          </div>}
          {Object.entries(alaCarteSelected).map(([name, item]) => (
            <div key={name} className="d-flex justify-content-between align-items-center mb-1">
              <span className="pe-2">
                {name} ({item.qty} {(item.chosenUnit || (Array.isArray(item.unit) ? item.unit[0] : item.unit) || 'lb').toUpperCase()})
              </span>
              <div className="d-flex align-items-center">
                <span className="me-2 fw-bold">${(item.qty * item.price).toFixed(2)}</span>
                <button className="btn btn-sm btn-link p-0 me-2" onClick={() => selectAlaCarteItem(name)}>✏️</button>
                <button className="btn btn-sm btn-link p-0 text-danger" onClick={() => { const u = {...alaCarteSelected}; delete u[name]; setAlaCarteSelected(u); }}>🗑️</button>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-2 pt-2 border-top">
          <div className="d-flex justify-content-between fw-bold">
            <span>Subtotal:</span><span>${subtotal}</span>
          </div>
          <p className="text-muted mb-0" style={{ fontSize: '0.65rem' }}>*Taxes and delivery shown at checkout</p>
        </div>
        {checkoutStep === 0 && <button className="btn btn-primary btn-sm w-100 mt-2 no-print" onClick={() => (menu1Persons || menu2Persons || Object.keys(alaCarteSelected).length) ? (subtotal < 200 ? Swal.fire({ title: 'Notice', text: "Orders under $200 are in-store only. Continue?", icon: 'info', showCancelButton: true }).then(r => r.isConfirmed && setCheckoutStep(1)) : setCheckoutStep(1)) : Swal.fire('Empty Cart', 'Add items first', 'error')}>CHECKOUT</button>}
      </div>
    </div>
  );

  return (
    <div className="container-fluid p-0 pb-5">
      <header className="border-bottom px-2 py-1 no-print" style={{ backgroundColor: '#003366' }}>
        <div className="d-flex align-items-center justify-content-between mx-auto" style={{ maxWidth: '1000px' }}>
          <img src="images/logo-removebg-preview.png" alt="Logo" style={{ height: '45px' }} />
          <img src="images/header.png" alt="Passover 2026" className="img-fluid rounded" style={{ maxHeight: '80px' }} />
        </div>
      </header>

     

      {renderTimer()}

      {/* Step 0: Menu Selection */}
      {checkoutStep === 0 && (
        <div className="row mt-3 px-2 g-3">
          <div className="col-md-8">
            {/* MENU CARDS */}
            <div className="row g-3 mb-4">
              {[1, 2].map(n => (
                <div key={n} className="col-md-6">
                  <div className="card h-100 shadow-sm border-0">
                    <img 
  src={n === 1 ? "/menu-1.png" : "/menu-2.jpg"} 
  className="card-img-top" 
  style={{ height: '150px', objectFit: 'cover' }} 
  alt="Menu" 
/>
                    <div className="card-body d-flex flex-column">
                      <h5 className="gold fw-bold mb-1">MENU #{n} * ${n === 1 ? 80 : 90}/person</h5>
                      <ul className="ps-3 mb-3 small">
                        {n === 1 ? (
                          <>
                            <li>Chopped liver with fried onions</li>
                            <li>Chicken soup with matzo ball</li>
                            <li>Gefilte Fish</li>
                            <li>Coleslaw</li>
                            <li>Romanian eggplant</li>
                            <li>Potato kugel</li>
                            <li>BBQ chicken</li>
                            <li>Beef Brisket with gravy</li>
                            <li>Stir fry vegetables</li>
                            <li>Garlic Potatoes</li>
                            <li>Chocolate roll cake</li>
                          </>
                        ) : (
                          <>
                            <li>Fishballs in tomato sauce</li>
                            <li>Vegetable soup</li>
                            <li>Salade cuite</li>
                            <li>Moroccan eggplant</li>
                            <li>Cooked carrots</li>
                            <li>Lemon chicken with olives</li>
                            <li>Beef shoulder roast with gravy</li>
                            <li>Stir fry vegetables</li>
                            <li>Garlic Potatoes</li>
                            <li>Chocolate roll cake</li>
                          </>
                        )}
                      </ul>
                      <button 
                        className="btn btn-success w-100 mt-auto" 
                        onClick={() => selectMenuQuantity(n, n === 1 ? menu1Persons : menu2Persons, n === 1 ? setMenu1Persons : setMenu2Persons)}
                      >
                        Select People
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* A-LA-CARTE SECTION */}
            <h4 className="gold mt-4 mb-2">A-LA-CARTE ITEMS</h4>
            <div className="row g-2">
              {alaCarteItems.map((item, i) => (
                <div key={i} className="col-md-6 col-lg-4">
                  <div className="card p-2 border-0 shadow-sm d-flex justify-content-between align-items-center">
                    <span className="small d-block">
                      <strong>{item.name}{item.isGF && <span className="gf-stamp ms-1">GF</span>}</strong>
                      <br/>
                      {Array.isArray(item.unit) ? (
                        <span className="text-nowrap">
                          <strong>${item.price}</strong>/{item.unit[0]} <small className="text-muted">or</small>{' '}
                          <strong>${item.pricePerAlternateUnit || item.pricePcs}</strong>/{item.unit[1]}
                        </span>
                      ) : (
                        <span>
                          <strong>${item.price}</strong>/{item.unit || 'lb'}
                        </span>
                      )}
                    </span>
                    <button 
                      className="btn btn-sm btn-outline-success" 
                      onClick={() => selectAlaCarteItem(item.name)}
                    >
                      +
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-5 p-4 bg-light rounded border border-warning">
              <h5 className="gold text-center mb-3">Addons and Special Requirements</h5>
              <p className="text-center mb-0">
                Place your regular order above, then call us at <strong>514-421-0121</strong> if you need to add any extras, 
                request modifications, or have special dietary/instruction requirements.
              </p>
              <p className="text-center small text-muted mt-2">
                (You can also use our Notes Section at Checkout)
              </p>
            </div>
          </div>

          <div className="col-md-4 d-none d-md-block">
            {renderCartContent()}
          </div>
        </div>
      )}

      {/* Step 1: Service Type */}
      {checkoutStep === 1 && (
        <div className="text-center py-5 no-print">
          <h3 className="gold">Select Service Type</h3>
          <div className="mt-4">
            <button className="btn btn-primary btn-lg m-2" onClick={() => { setDelivery(false); setCheckoutStep(2); }}>PICKUP (Free)</button>
            <button className="btn btn-primary btn-lg m-2" onClick={() => { setDelivery(true); setCheckoutStep(2); }}>DELIVERY (+$25 + tax)</button>
          </div>
          <button className="btn btn-outline-secondary mt-3" onClick={() => setCheckoutStep(0)}>Back to Menu</button>
        </div>
      )}

      {/* Step 2: Date & Time */}
      {checkoutStep === 2 && (
        <div className="container text-center py-5 no-print">
          <h3 className="gold">Select Date & Preferred Time</h3>
          <div className="mt-4 mx-auto" style={{maxWidth:'400px'}}>
            <label className="fw-bold mb-1">Select Date:</label>
            <input 
              type="date" 
              className="form-control mb-3" 
              min="2026-03-26" 
              max="2026-04-07"
              value={formData.date} 
              onChange={(e) => setFormData({...formData, date: e.target.value, time: ''})} 
            />
            
            {!delivery && formData.date && (
              <>
                <label className="fw-bold mb-1">Select Pickup Time (30 min increments):</label>
                <select className="form-select mb-3" value={formData.time} onChange={(e) => setFormData({...formData, time: e.target.value})}>
                  <option value="">-- Choose Time --</option>
                  {getAvailableTimes(formData.date).map(t => <option key={t} value={t}>{t}</option>)}
                </select>
              </>
            )}

            {delivery && formData.date && <p className="small text-muted mb-3">Drivers deliver throughout the day; specific times are not available for delivery.</p>}

            <button className="btn btn-success w-100" disabled={!formData.date || (!delivery && !formData.time)} onClick={() => setCheckoutStep(3)}>CONTINUE</button>
          </div>
          <button className="btn btn-outline-secondary mt-3" onClick={() => setCheckoutStep(1)}>Back</button>
        </div>
      )}

    {/* Step 3: Contact & Payment */}
{checkoutStep === 3 && (
  <div className="row mt-3 px-3 no-print align-items-start d-flex">
    <div className="col-md-12 mb-3">
      <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => setCheckoutStep(2)}>Back to Date</button>
      <button className="btn btn-sm btn-outline-secondary" onClick={() => setCheckoutStep(0)}>Back to Menu</button>
    </div>
    
    <div className="col-md-7">
      <h4 className="gold border-bottom pb-2">
        {delivery ? 'Delivery' : 'Pickup'} Contact Info
      </h4>

      <div className="row g-2">
        <div className="col-12">
          <input type="text" id="name" placeholder="Full Name *" className="form-control" value={formData.name} onChange={handleInputChange} />
        </div>
        <div className="col-md-6">
          <input type="email" id="email" placeholder="Email *" className="form-control" value={formData.email} onChange={handleInputChange} />
        </div>
        <div className="col-md-6">
          <input type="tel" id="phone" placeholder="Phone *" className="form-control" value={formData.phone} onChange={handleInputChange} />
        </div>
        <div className="col-12">
          <input type="text" id="company" placeholder="Company Name" className="form-control" value={formData.company} onChange={handleInputChange} />
        </div>

        {/* Address fields - integrated into the grid */}
        {delivery && (
          <>
            <div className="col-md-4">
              <input type="text" id="streetNumber" placeholder="Street #" className="form-control" value={formData.streetNumber} onChange={handleInputChange} required />
            </div>
            <div className="col-md-8">
              <input type="text" id="streetName" placeholder="Street Name" className="form-control" value={formData.streetName} onChange={handleInputChange} required />
            </div>
            <div className="col-md-6">
              <input type="text" id="city" list="city-options" placeholder="City" className="form-control" value={formData.city} onChange={handleInputChange} required />
              <datalist id="city-options">
                <option value="Dollard-des-Ormeaux" /><option value="Pierrefonds" /><option value="Roxboro" />
                <option value="Kirkland" /><option value="Pointe-Claire" /><option value="Beaconsfield" />
                <option value="Baie-D'Urfe" /><option value="Sainte-Anne-de-Bellevue" /><option value="Senneville" />
                <option value="Dorval" /><option value="Montreal" /><option value="Saint-Laurent" />
                <option value="Saint-Lazare" /><option value="Hampstead" /><option value="Cote Saint-Luc" />
                <option value="Montreal-West" /><option value="Westmount" /><option value="Laval" />
              </datalist>
            </div>
            <div className="col-md-6">
              <input type="text" id="postalCode" placeholder="Postal Code (A1B 2C3)" className="form-control" value={formData.postalCode} onChange={handleInputChange} maxLength="7" required />
            </div>
          </>
        )}
      </div>

      <h4 className="gold border-bottom pb-2 mt-4">Payment Information</h4>
      <p className="small text-primary fw-bold mb-2">
        {!delivery 
          ? "Skip the line: Provide your card details to be billed automatically once your order is ready, or simply pay at the counter during pickup." 
          : "Credit card information is required for all delivery orders."}
      </p>
      <div className="row g-2">
        <div className="col-12">
          <input type="text" id="cardName" placeholder={`Name on Card ${delivery ? '*' : '(Optional for Pickup)'}`} className="form-control" value={formData.cardName} onChange={handleInputChange} />
        </div>
        <div className="col-md-8">
          <input type="text" id="ccNumber" placeholder={`16 Digit Card Number ${delivery ? '*' : '(Optional for Pickup)'}`} className="form-control" value={formData.ccNumber} onChange={handleInputChange} />
        </div>
        <div className="col-md-4">
          <input type="text" id="expDate" placeholder={`MM/YY ${delivery ? '*' : ''}`} className="form-control" value={formData.expDate} onChange={handleInputChange} />
        </div>
      </div>
      <div className="mt-3">
        <label className="small fw-bold">Special requirements or notes:</label>
        <textarea id="specialNotes" className="form-control" rows="2" value={formData.specialNotes} onChange={handleInputChange}></textarea>
      </div>
    </div>

    <div className="col-md-5">
      <div className="card p-3 bg-light border-0 shadow-sm sticky-top">
        <h5 className="gold border-bottom pb-2">Order Summary: #{orderNumber}</h5>
        <div className="mb-2">
          <p className="mb-0 fw-bold">Service: {delivery ? 'DELIVERY' : 'PICKUP'}</p>
          <p className="mb-0 small">Date: {formData.date}</p>
          {!delivery && formData.time && <p className="mb-0 small fw-bold text-success">Time: {formData.time}</p>}
        </div>
        <div className="order-items small mb-3">
          {menu1Persons > 0 && <div className="d-flex justify-content-between"><span>Menu #1 ({menu1Persons} people)</span><span>${(menu1Persons * 80).toFixed(2)}</span></div>}
          {menu2Persons > 0 && <div className="d-flex justify-content-between"><span>Menu #2 ({menu2Persons} people)</span><span>${(menu2Persons * 90).toFixed(2)}</span></div>}
          {Object.entries(alaCarteSelected).map(([n, i]) => <div key={n} className="d-flex justify-content-between"><span>{n} (x{i.qty})</span><span>${(i.qty * i.price).toFixed(2)}</span></div>)}
          {delivery && <div className="d-flex justify-content-between text-primary"><span>Delivery Fee</span><span>$25.00</span></div>}
        </div>
        <div className="border-top pt-2 small">
          <div className="d-flex justify-content-between"><span>Subtotal:</span><span>${subtotal}</span></div>
          <div className="d-flex justify-content-between text-muted"><span>GST (5%):</span><span>${taxes.gst}</span></div>
          <div className="d-flex justify-content-between text-muted"><span>QST (9.975%):</span><span>${taxes.qst}</span></div>
          <h4 className="d-flex justify-content-between border-top mt-2 pt-2 text-dark">
            <span>Total:</span><span>${total}</span>
          </h4>
        </div>
        <button className="btn btn-success w-100 mt-3 btn-lg" onClick={() => validateStep3() && handleSubmit()}>
          SUBMIT ORDER
        </button>
      </div>
    </div>
  </div>
)}
      {checkoutStep === 0 && <div className="d-md-none fixed-bottom bg-white border-top p-2 no-print">{renderCartContent(true)}</div>}

      <footer className="mt-5 pb-4 pt-4 border-top">
        <div className="container text-center">
          <div className="row g-3">
            <div className="col-md-4">
              <p className="small mb-1"><span className="gf-stamp">GF</span> = Gluten Free </p>
              <p className="small mb-0"><strong>OPEN CHOL HAMOED:</strong><br/> Sunday through Tuesday </p>
            </div>
            <div className="col-md-4">
              <p className="small mb-1 fw-bold text-danger">*Minimum 4 people to order </p>
              <p className="small mb-0 fw-bold">NO KITNIYOT </p>
            </div>
            <div className="col-md-4">
              <p className="small mb-1"><strong>For more info:</strong> 514.421.0421 </p>
              <p className="small mb-0">
                <a href="https://www.paradisekosher.com" target="_blank" rel="noreferrer" className="text-decoration-none gold">
                  www.paradisekosher.com 
                </a>
              </p>
            </div>
        <div style={{ marginTop: '8px', fontSize: '14px', color: '#333' }}>
    Webmaster Design & Development| Copyright 2026 | by 
    <br></br>
    <a 
        href="https://devlogic.ca" 
        target="_blank" 
        rel="noopener noreferrer"
        style={{ 
            color: '#0d6efd', 
            textDecoration: 'none', 
            fontWeight: '700', 
            borderBottom: '2px solid #0d6efd' 
        }}
    >
         DEVLOGIC
    </a>
</div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default MainApp;